import { distance as turfDistance } from '@turf/turf';

/**
 * Finds where the track is a given distance in, by the recording's own distance: the line is
 * measured once and each lookup is a search along it. Null without a line to walk.
 */
export function trackPositioner(
  coordinates: number[][],
  totalMeters: number
): (meters: number) => [number, number] | null {
  if (coordinates.length < 2 || !(totalMeters > 0)) return () => null;
  const along = [0];
  for (let i = 1; i < coordinates.length; i++) {
    along.push(along[i - 1] + turfDistance(coordinates[i - 1].slice(0, 2), coordinates[i].slice(0, 2), { units: 'meters' }));
  }
  const lineMeters = along[along.length - 1];

  return (meters) => {
    const target = Math.min(Math.max(meters / totalMeters, 0), 1) * lineMeters;
    let low = 0;
    let high = along.length - 1;
    while (high - low > 1) {
      const middle = (low + high) >> 1;
      if (along[middle] <= target) low = middle;
      else high = middle;
    }
    const span = along[high] - along[low];
    const fraction = span > 0 ? (target - along[low]) / span : 0;
    const [fromLng, fromLat] = coordinates[low];
    const [toLng, toLat] = coordinates[high];
    return [fromLng + (toLng - fromLng) * fraction, fromLat + (toLat - fromLat) * fraction];
  };
}
